import React from "react";
import { UI_STYLES } from "../../styles/uiStyles";
import { motion } from "framer-motion";

const ScreenLoader: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  return (
    isLoading ? (
    <motion.div 
    initial={{ opacity: 1 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3, ease: "easeInOut" }}
    
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: UI_STYLES.colors.darkBlue,
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      
    }}>
      <div className="loader" />
      <style>{`
        .loader {
          border: 6px solid #f3f3f3;
          border-top: 6px solid #3b82f6;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </motion.div>
    ) : null
  );
};

export default ScreenLoader; 
